import api from '../api/api';
import { getErrorMessage } from '../utils/errorMessages';

export const userService = {
  async getUsage() {
    try {
      const response = await api.get('/api/user/usage');
      return response.data;
    } catch (error) {
      console.error('Get usage error:', error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  },

  async getUsageHistory(months = 6) {
    try {
      const response = await api.get(`/api/user/usage/history?months=${months}`);
      return response.data;
    } catch (error) {
      console.error('Get usage history error:', error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  },

  async getUsageWarnings() {
    try {
      const response = await api.get('/api/user/usage/warnings');
      return response.data;
    } catch (error) {
      console.error('Get usage warnings error:', error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  }
};